import { EssHeader } from '@/components/ess/EssHeader';
import { FC } from 'react';
import { FiClock } from 'react-icons/fi';
import { NavPage } from '../../../../components/page/Breadcrumbs';
import strings from '../../ess.translations';

export const MyScheduleHeader: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.mySchedule.header,
      to: `/ess/my-schedule`
    }
  ];

  return <EssHeader title={strings.mySchedule.header} icon={FiClock} breadcrumbs={breadcrumbs} />;
};
